import React, { useState, useRef } from "react";
import ColorPicker from "fantastic/components/common/ColorPicker";
import classNames from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';

import usedColors from "fantastic/lib/usedColors";
import Size from "./Size";
import Style from "./Style";

const Settings = (props) => {
  const {
    onChange,
    scrollToIfNeeded,
    style,
    size,
    radius,
    label = i18n.t('border')
  } = props;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const color = props.color.value || "transparent";
  const formGroup = useRef(null);
  const colorButtonEl = useRef(null);

  const openColorPicker = () => {
    const { scrollToIfNeeded } = props;
    setDisplayColorPicker(!displayColorPicker);
    if (scrollToIfNeeded) scrollToIfNeeded(formGroup.current);
  };

  const closeColorPicker = ({ target }) => {
    if (colorButtonEl.current.contains(target)) return;
    setDisplayColorPicker(false);
  };

  const handleColorChange = color => {
    const {
      onChange,
      color: { field }
    } = props;
    const newValue = color.hex === "transparent" ? "" : color.hex;
    onChange(field, newValue);
  };

  const styleParams = {
    onChange,
    style,
    scrollToIfNeeded,
    label: ''
  };

  const sizeParams = {
    onChange,
    size,
    scrollToIfNeeded,
    min: 0,
    max: size.max || 100
  };

  return (
    <>
      <div ref={formGroup} className="form-group">
        <label>{label}</label>
        <div className="btn-group btn-group-block">
          <button
            className={`btn btn-form btn-color`}
            onClick={openColorPicker}
            ref={colorButtonEl}
          >
            <span style={{ background: color }}></span>
          </button>
          <Style {...styleParams} />
          <Size {...sizeParams}/>
        </div>
        <OutsideClickHandler onOutsideClick={closeColorPicker}>
          {displayColorPicker && (
            <ColorPicker
              color={color}
              onChange={handleColorChange}
              presetColors={usedColors(props)}
            />
          )}
        </OutsideClickHandler>
      </div>
    </>
  );
};

export default Settings;
